import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import AdminContactService from '../../api/services/AdminContactService';

const SaleContactList = () => {
    const [Error, setError] = useState('');
    const [isLoading, setisloading] = useState(true);
    const [ContactList, setContactList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = ContactList.slice(firstIndex, lastIndex);
    const npage = Math.ceil(ContactList.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const getContactList = async () => {
        try {
            let responseData = await AdminContactService.saleindex().json()
            setContactList(responseData.data)
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getContactList();

        }
        else {
            navigate('/');
        }

    }, [])
    const handleDelete = async (e) => {

        try {


            let responseData = await AdminContactService.salecontactdestroy(e).json()
            if (responseData.status === true) {
                swal("Contact Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getContactList();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    const updatechecktatus = async (e) => {
        e.preventDefault();
        let userid = e.target.id
        try {
            var userData = {
                id: userid
            }
            let responseData = await AdminContactService.updatesalecheckstatus(userData).json();
            if (responseData.status === true) {
                swal("Updated!!!").then((willUpdate) => {
                    if (willUpdate) {
                        getContactList();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    return (
        <>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Sale Contact List</h4>

                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th >
                                                        <strong>No.</strong>
                                                    </th>
                                                    <th>
                                                        Checked
                                                    </th>
                                                    <th>
                                                        <strong>Firstname</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Email</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Phone</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Message</strong>
                                                    </th>
                                                    <th><strong>Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.map((element, index) => {

                                                        return (
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td>
                                                                    {index + 1}
                                                                </td>
                                                                <td>{element.is_checked == 1 ? <span className="btn btn-success btn-sm ms-1">Checked</span> : <span className="btn btn-danger btn-sm ms-1">Not Checked</span>}<Link id={element.id}
                                                                    onClick={updatechecktatus}> Change?</Link></td>
                                                                <td>
                                                                    {element.firstName}

                                                                </td>

                                                                <td>{element.email}</td>
                                                                <td>{element.phone}</td>
                                                                <td>{element.message}</td>
                                                                <td>
                                                                    <div className="d-flex">

                                                                        <Link
                                                                            onClick={() =>
                                                                                swal({
                                                                                    title: "Are you sure?",

                                                                                    icon: "warning",
                                                                                    buttons: true,
                                                                                    dangerMode: true,
                                                                                }).then((willDelete) => {
                                                                                    if (willDelete) {
                                                                                        (handleDelete(element.id));
                                                                                    }
                                                                                })
                                                                            }

                                                                            className="btn btn-danger shadow btn-xs sharp"
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {ContactList.length < lastIndex ? ContactList.length : lastIndex}
                                                {" "}of {ContactList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}

        </>
    );
};

export default SaleContactList;
